/// <amd-module name="Feed/Connect/Redux/ConnectToFeed/ConnectToFeedModule" />
import { ISagaModule } from "redux-dynamic-modules-saga";

import { VSSPageDataModule } from "VSS/Redux/Modules/VSSPageData";

import { getFeedHubModules } from "Feed/Core/Redux/FeedHub";
import { getTfsPageDataModule } from "Tfs/ReduxCommon/Modules/TfsPageData/TfsPageDataModule";

import { IConnectToFeedOwnState } from "./ConnectToFeedContracts";
import { connectToFeedReducer } from "./ConnectToFeedReducers";
import rootSaga from "./ConnectToFeedSagas";

const ConnectToFeedModule: ISagaModule<IConnectToFeedOwnState> = {
    id: "feed-connect-to-feed",
    reducerMap: {
        connectToFeed: connectToFeedReducer
    },
    sagas: [rootSaga]
};

export function getConnectToFeedModule() {
    return [VSSPageDataModule, getTfsPageDataModule(), getFeedHubModules(), ConnectToFeedModule];
}
